'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var instance = new _vue2.default();
exports.default = instance;


//////////////////
// WEBPACK FOOTER
// ./~/vue-e-bus/lib/index.js
// module id = 681
// module chunks = 1